export default "__VITE_ASSET__DiwFjpbT__"